import React, { Component } from 'react';
import './../css/master.css';
import './../css/season.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 

var httpURL = '';
var queryString = require('querystring');
var lstSeason =[];
var seasonIdCol 	= 'td:eq(0)';
var seasonCol 		= 'td:eq(1)';

class Season extends Component {
  constructor(props){
	super(props);
	this.state={
		season:[],
		flg:true,
		loader:'none',
		opacity:1,
	}
  }
  
  componentDidMount =()=>{
	this.setState({loader:'block', opacity:0.5});
	axiosInstance.get(httpURL+'/a/mst/ssn/list',{
		  withCredentials: true
	}).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			this.setState({
				season:response.data.lstSeason,
			})
			lstSeason = this.state.season;
			this.setSeasonTable();
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.CSURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	}); 
  }
  
  setSeasonTable =()=> {
	$('#seasonAddForm').trigger('reset');  
	$('#seasonTableBody tr').remove();
	var table = document.getElementById('seasonTable');
	var tbody = document.getElementById('seasonTableBody');
	var filterSeason = $('#season').val().trim().toLowerCase();
		
	for(var i=0; i<lstSeason.length; i++){
		var id = lstSeason[i].seasonId;
		var season = lstSeason[i].season;
			
		var row = document.createElement('tr');
			
		row.id = id;
		row.onclick =(e)=>{
			$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
			this.setSeasonForm($(e.target).closest('tr').attr('id'));
			this.setState({flg:false})
		}
		
		if(season.toLowerCase().indexOf(filterSeason) === -1)
			continue;
		
		this.addTD(row, id, 'no-display');
		this.addTD(row, season, '');
		
		tbody.append(row);
	}
	table.append(tbody);
  }
	
	addTD(row, val, classname){
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}
	
	async setSeasonForm(id){
		var seasonData = await this.getSeasonData(id);
		if(seasonData !== -1){
			$('#inp_season').val(seasonData.season);
		}
	}
	
	getSeasonData(id){
		for(var i = 0; i < lstSeason.length; i++){
			if(id == lstSeason[i].seasonId){
				return lstSeason[i];
			}
		}
		return -1;
	}
	
	addSeasonReady =()=>{
		$('#seasonAddForm').trigger('reset');
		this.setState({flg:true})
	}
	
	maintainSeason =()=>{
		if(this.state.flg){
			this.addSeason();
		}else{
			this.editSeason();
		}
	}
	
	addSeason=()=>{
		var seasonArr 		= {};
		var season			= $('#inp_season').val().toUpperCase();
		if(season == ''){
			toast.warning('Please fill season');
			document.getElementById('inp_season').focus();
			return false;
		}
	
		seasonArr={'seasonId': 0, 'season':season};
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/a/mst/ssn/save', 
			queryString.stringify({'season':JSON.stringify(seasonArr)}), {withCredentials:true}
		).then((response)=>{	
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg);
				seasonArr.seasonId = response.data.seasonId;
				lstSeason.push(seasonArr);
				this.setSeasonTable();
				this.setSeasonForm(response.data.seasonId);
				this.highlightRow('seasonTableBody', response.data.seasonId);
				this.setState({flg : false})
			}
			else{
				toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e)=>{
			toast.error("Service failed "+e);
		});
	}

	editSeason=()=>{
		var seasonArr 		= {};
		var seasonId 		= $('#seasonTableBody tr.selected').find(seasonIdCol).text();
		var season			= $('#inp_season').val().toUpperCase();
		
		if(seasonId == ''){
			toast.warning('Please select row');
			return false;
		}
		
		if(season == ''){
			toast.warning('Please fill season');
			document.getElementById('inp_season').focus();
			return false;
		}
		
		seasonArr={'seasonId': seasonId, 'season':season}
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/a/mst/ssn/save', 
			queryString.stringify({'season':JSON.stringify(seasonArr)}), {withCredentials:true}
		).then((response)=>{	
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg);
				var seasonIdx = this.getIdxSeason(seasonId);
				lstSeason.splice(seasonIdx,1,seasonArr);
				this.setSeasonForm(seasonId);
				this.setSeasonTable();
				this.highlightRow('seasonTableBody', seasonId);
			}
			else{
				toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e)=>{
			toast.error("Service failed "+e);
		});
	}

	getIdxSeason(seasonId){
		for(var i=0; i<lstSeason.length; i++){
			if(lstSeason[i].seasonId == seasonId){
				return i;
			}
		}
		return -1;
	}

	highlightRow(table, id){
		$('#'+table+' tr').each(function(){
			var seasonId = $(this).find(seasonIdCol).text();
			if(seasonId == id){
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}

	
  render() {
	httpURL = window.httpURL;  
    return (
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div> 
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-7 col-centered">
						<div className="col-sm-5 col-xs-11 padding-remove">
							<table className="tableLayout">
								<thead>
									<tr>
										<th style={{width:50, display:'none'}}>Season Id</th>
										<th style={{width:100}}>
											<input onChange={this.setSeasonTable} type="text" className="form-control inp-search" id="season" placeholder="Season" />
										</th>
									</tr>
								</thead>
							</table>
							<div className="seasonTableDiv col-sm-12 col-xs-11 padding-remove">
								<table id="seasonTable" className="tableLayout">
									<colgroup>
										<col width="100" />
									</colgroup>
									<tbody id="seasonTableBody">
									</tbody>
								</table>
							</div>
						</div>
						<div className="col-sm-1 col-xs-1">
							<span id="addSeason" title="Add Season" onClick={this.addSeasonReady} className="addIcon glyphicon glyphicon-plus-sign"></span>
						</div>
						<div className="col-sm-6 col-xs-12">
							<form id="seasonAddForm" className="form-horizontal">
								<div className="form-group">
									<label className="control-label col-sm-5">Season:</label>
									<div className="col-sm-7">
										<input type="text" className="form-control" placeholder="Season" id="inp_season"/>
									</div>
								</div>
								<div className="form-group" style={{marginTop:50}}>
									<div className="col-sm-12 text-center">
										<button type="button" onClick={this.maintainSeason} className="btn btn-warning">Save</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default Season;
